import React from "react";
import { useDispatch } from "react-redux";
import { toggleActivityTypeSelection } from "../../../../redux/slices/activityTypes";

// will display the name of a single activity type
//clicking on any type will SELECT theat activity type
// only the subtypes of the SELECTED activity type will be displayed in the below sliders

export default function ActivityType({ id, name, isSelected, activity_category_id }) {
  const dispatch = useDispatch();
  const handleClick = () => {
    dispatch(toggleActivityTypeSelection({ id }));
  };

  return (
    <div className={isSelected ? "activity_type active" : "activity_type"} onClick={handleClick}>
      <p className="activity_type__name"> {name} </p>
    </div>
  );
}
